
import React from 'react';
import { CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BanknoteIcon } from 'lucide-react';
import { SecurityIcon } from '../BorrowingsIcons';
import { AddLoanDialog } from './AddLoanDialog';

interface DebtManagementHeaderProps {
  mainView: "loans" | "loan-details";
  currentLoan: any | null;
  showAddLoanDialog: boolean;
  setShowAddLoanDialog: (show: boolean) => void;
  handleAddLoan: () => void;
  handleBackToLoansList: () => void;
}

export const DebtManagementHeader: React.FC<DebtManagementHeaderProps> = ({
  mainView,
  currentLoan,
  showAddLoanDialog,
  setShowAddLoanDialog,
  handleAddLoan,
  handleBackToLoansList
}) => {
  return (
    <CardHeader className="pb-3">
      <div className="flex items-center justify-between">
        <div>
          <CardTitle className="text-xl flex items-center gap-2">
            {mainView === "loans" ? (
              <>
                <BanknoteIcon className="h-5 w-5" />
                Debt Management
              </>
            ) : (
              <>
                <SecurityIcon className="h-5 w-5" />
                Borrowing Details
              </>
            )}
          </CardTitle>
          <CardDescription>
            {mainView === "loans"
              ? "Manage all types of borrowings, covenants, and repayment schedules"
              : currentLoan ? `Viewing ${currentLoan.instrumentType} from ${currentLoan.lender}` : "View borrowing details"}
          </CardDescription>
        </div>
        {mainView === "loans" ? (
          <AddLoanDialog 
            open={showAddLoanDialog} 
            setOpen={setShowAddLoanDialog} 
            handleAddLoan={handleAddLoan}
          />
        ) : (
          <Button variant="outline" onClick={handleBackToLoansList}>
            Back to Borrowings
          </Button>
        )}
      </div>
    </CardHeader>
  );
};
